<div class="tw:flex tw:items-center tw:justify-center tw:font-medium" [ngStyle]="avatarStyle">
	{{ name() | initials }}
</div>
